const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.my_deliveries/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.my_deliveries/LIST_MY_DELIVERIES_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
